<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form (submit)="search()" #form="ngForm" class="form-validate">
      <div class="row mb-2">
        <label class="col-form-label col-auto">
          <i class="bi bi-search me-1"></i>
          ค้นหา
        </label>
      </div>
      <hr>
      <div class="row mb-2">
        <div class="col-2">
          <div class="form-check">
            <input class="form-check-input " type="radio" name="typeSearch" id="flexRadioDefault1"
                   [checked]="typeSearch()" (change)="updateSearchType(true)">
            <label class="form-check-label" for="flexRadioDefault1">
              เลขประจำตัวประชาชน
            </label>
          </div>
        </div>
        <div class="col-2">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="typeSearch" id="flexRadioDefault2"
                   [checked]="!typeSearch()" (change)="updateSearchType(false)">
            <label class="form-check-label" for="flexRadioDefault2">
              ชื่อ-นามสกุล
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        @if (typeSearch()) {
          <label for="personalId" class="col-form-label col-auto">เลขประจำตัวประชาชน</label>
          <div class="col-auto">
            <input type="text" class="form-control" id="personalId" [(ngModel)]="digitalAddressParams.pid"
                   name="personalId"
                   #personalInput="ngModel" [required]="typeSearch()">
            @if (personalInput.invalid && (personalInput.dirty || personalInput.touched)) {
              <custom-error *ngIf="personalInput.hasError('required')" error="*จำเป็น"></custom-error>
            }
          </div>
        } @else {
          <label for="name" class="col-form-label col-auto">ชื่อ</label>
          <div class="col-auto">
            <input type="text" class="form-control" id="name" [(ngModel)]="digitalAddressParams.fname" name="name"
                   #nameInput="ngModel" [required]="!typeSearch()">
            @if (nameInput.invalid && (nameInput.dirty || nameInput.touched)) {
              <custom-error *ngIf="nameInput.hasError('required')" error="*จำเป็น"></custom-error>
            }
          </div>
          <label for="lastname" class="col-form-label col-auto">นามสกุล</label>
          <div class="col-auto">
            <input type="text" class="form-control" id="lastname" [(ngModel)]="digitalAddressParams.lname"
                   name="lastname"
                   #nameInput="ngModel" [required]="!typeSearch()">
            @if (nameInput.invalid && (nameInput.dirty || nameInput.touched)) {
              <custom-error *ngIf="nameInput.hasError('required')" error="*จำเป็น"></custom-error>
            }
          </div>
        }
        <div class="col-auto">
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-search me-1"></i>ค้นหาข้อมูล
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card custom-box border-0">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>รายละเอียดการค้นหา</caption>
        <thead>
        <tr>
          <th nowrap scope="col">ลำดับ</th>
          <th nowrap scope="col">เลขประจำตัวประชาชน</th>
          <th nowrap scope="col">ชื่อ</th>
          <th nowrap scope="col">นามสกุล</th>
          <th nowrap scope="col">ที่อยู่ตามทะเบียนบ้าน</th>
          <th nowrap scope="col">ที่อยู่ปัจจุบัน</th>
          <th nowrap scope="col">เบอร์โทรศัพท์</th>
          <th nowrap scope="col">อีเมล</th>
          <th nowrap scope="col">Line ID</th>
          <th nowrap scope="col">แหล่งที่มาของข้อมูล</th>
          <th nowrap scope="col">วันที่สร้างข้อมูล</th>
          <th nowrap scope="col">วันที่ปรับปรุงข้อมูลล่าสุด</th>
        </tr>
        </thead>
        <tbody>
          @for (item of pageData?.content; let i = $index; track item) {
            <tr>
              <td scope="row">{{ (pageData.number * pageData.size) + (i + 1) }}</td>
              <td>{{ item?.personalId || '-' }}</td>
              <td nowrap>{{ item?.firstName || '-' }}</td>
              <td nowrap>{{ item?.lastName || '-' }}</td>
              <td>{{ item?.fullAddressPersonalData || '-' }}</td>
              @if (item?.fullAddressErmRegMain == null) {
                <td>{{ item?.fullAddressPersonalData || '-' }}</td>
              }@else {
                <td>{{ item?.fullAddressErmRegMain || '-' }}</td>
              }
              <td>{{ item?.phoneNumber || '-' }}</td>
              <td>{{ item?.email || '-' }}</td>
              <td>{{ item?.line || '-' }}</td>
              @if(item?.regSource == "UNKNOWN"){
                <td> - </td>
              } @else {
                <td>{{ item?.regSource || '-' }}</td>
              }
              @if(item?.regSource == "UNKNOWN"){
                <td>{{item?.personalCreatedDateTime | thaidatetime :{showTime:false} || '-'}}</td>
                <td>-</td>
              } @else {
                <td>{{item?.ermCreatedDateTime |thaidatetime :{showTime:false} || '-'}} </td>
                <td>{{item?.ermUpdatedDateTime |thaidatetime :{showTime:false} || '-'}}</td>
              }
            </tr>
          } @empty {
            <tr>
              <td colspan="10">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="row">
        <div class="col-12">
          <ngb-pagination class="d-flex justify-content-end"
                          [rotate]="true"
                          [ellipses]="false"
                          [boundaryLinks]="true"
                          [page]="pageData?.number + 1"
                          [pageSize]="pageData?.size"
                          [maxSize]="5"
                          (pageChange)="search($event)"
                          [collectionSize]="pageData?.totalElements"/>
        </div>
      </div>
    </div>
  </div>
</div>
